import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgForm }   from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  private schoolUrl   = environment.apiUrl + 'api/school/';
  private batchUrl    = environment.apiUrl + 'api/batches/';
  currentUser         = JSON.parse(localStorage.getItem('currentUser') || '{}');
  public user_id      = this.currentUser.userDetails.id;
  public member_id    = this.currentUser.userDetails.member_id;
  public role_id      = this.currentUser.userDetails.role_id;
  public image_path   = "https://www.storage.anudip.org/home/storage/";


  public getDashboardDetails(data:any) {
    return this.http.post(this.schoolUrl+'get-dshboard-details-for-dean',data);
  }
  
}
